import React from "react";
import { Phone } from "lucide-react";

const PHONES = [
  { city: "USA", number: "+1 302 556 8855", tel: "+13025568855" },
  { city: "Switzerland", number: "+41 31 552 12 10", tel: "+41315521210" },
  { city: "Portugal", number: "+351 963 530 160", tel: "+351963530160" },
];

export const ContactHero = ({ t }) => (
  <section className="bg-[#0F1B2D] text-white pt-28 sm:pt-36 pb-16 sm:pb-20 relative grain">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="overline text-[#C4A46A]">{t.contact.kicker}</div>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">{t.contact.title}</h1>
      <span className="gold-rule mt-8 block" />
    </div>
  </section>
);

export const ContactSuccess = ({ t, onReset }) => (
  <div data-testid="contact-success" className="bg-[#0F1B2D] text-white p-12">
    <div className="overline text-[#C4A46A]">Northcrest</div>
    <h2 className="mt-4 font-display text-3xl tracking-tight">{t.contact.success}</h2>
    <span className="gold-rule mt-6 block" />
    <button
      onClick={onReset}
      data-testid="contact-reset"
      className="mt-8 px-6 py-3 border border-[#C4A46A] text-[#C4A46A] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#C4A46A]/10"
    >
      {t.common.sendMessage}
    </button>
  </div>
);

export const PhonesBlock = ({ t }) => (
  <div className="bg-[#0F1B2D] text-white p-10" data-testid="phones-block">
    <Phone size={20} className="text-[#C4A46A]" />
    <h3 className="mt-4 font-display text-2xl tracking-tight">{t.contact.phonesT}</h3>
    <span className="gold-rule mt-4 block" />
    <ul className="mt-8 space-y-6">
      {PHONES.map((p) => (
        <li key={p.tel} className="border-t border-white/10 pt-5 first:border-t-0 first:pt-0">
          <div className="overline text-white/55">{p.city}</div>
          <a
            href={`tel:${p.tel}`}
            data-testid={`phone-${p.city.toLowerCase()}`}
            className="mt-2 inline-block font-display text-xl lg:text-2xl tracking-tight text-[#C4A46A] hover:text-white transition-colors"
          >
            {p.number}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
